import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedConstants } from '@shared/Constants';
import { Severity } from 'src/app/components/note/note.component';
import { TBaseSettingsTabParams } from '../project-settings.component';

@Component({
  selector: 'app-prompts',
  templateUrl: './prompts.component.html',
  styleUrls: ['./prompts.component.scss'],
})
export class PromptsComponent {
  public params: TBaseSettingsTabParams;

  public centerNewsDescription = `Use ${SharedConstants.CENTER_NAME} to place center's name and ${SharedConstants.CENTER_CITY} to use center's city`;
  public centerNewsSeverity: Severity = Severity.Info;

  constructor(
    public dialogRef: MatDialogRef<PromptsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TBaseSettingsTabParams
  ) {
    this.params = data;
  }
}
